import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const referralTransitionMenuRegistry = {
    core_referralTransition: {
        label: "Referral Transition",
        link: PAGE_URL.REFERRAL_TRANSITION_PAGE,
        key: PAGE_URL.REFERRAL_TRANSITION_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default referralTransitionMenuRegistry;
